import { PLAY_AGAIN_QUIZ, QUIZ_COMPLETED, QUIZ_IN_PROGRESS, RESET_QUIZ_STATE } from "../actions/action_types";

export default function quizStateReducer(state = { quizInProgress: false, quizCompleted: false, playAgain:false }, action) {
    switch (action.type) {
        case QUIZ_IN_PROGRESS:
            return {...state, quizInProgress: true, playAgain:false }
        case QUIZ_COMPLETED:
            return {...state, quizCompleted: true }
        case RESET_QUIZ_STATE:
            return { quizInProgress: false, quizCompleted: false, playAgain:false }
        case PLAY_AGAIN_QUIZ:
            return {...state, playAgain:true}
        default:
            return state
    }
}